import { render, staticRenderFns } from "./SkupTema2Forma.vue?vue&type=template&id=1c44e629&scoped=true&"
import script from "./SkupTema2Forma.vue?vue&type=script&lang=js&"
export * from "./SkupTema2Forma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c44e629",
  null
  
)

export default component.exports